import { useState } from "react";

import {

    Send,

    Clock3,

    MessageSquare,

    RefreshCcw,

    FileText,

    MapPin,

    Phone,

    MessageCircle

} from "lucide-react";

import Card from "../shared/Card";
import Button from "../shared/Button";

import { formatDate } from "../../utils/formatDate";

export default function RemarksCard({

    activities = [],

    onAdd

}){

    const [

        remark,

        setRemark

    ] = useState("");

    const [

        loading,

        setLoading

    ] = useState(false);

    async function handleSubmit(){

        if(!remark.trim()){

            return;

        }

        try{

            setLoading(true);

            await onAdd?.(

                remark

            );

            setRemark("");

        }finally{

            setLoading(false);

        }

    }

    function handleKeyDown(e){

        if(

            (e.ctrlKey || e.metaKey)

            &&

            e.key==="Enter"

        ){

            handleSubmit();

        }

    }

    function getActivity(activity){

        switch(activity.activity_type){

            case "remark":

                return{

                    icon:<MessageSquare size={16}/>,

                    title:"Remark"

                };

            case "status_change":

                return{

                    icon:<RefreshCcw size={16}/>,

                    title:"Status Updated"

                };

            case "document_upload":

                return{

                    icon:<FileText size={16}/>,

                    title:"Document Uploaded"

                };

            case "address_update":

                return{

                    icon:<MapPin size={16}/>,

                    title:"Address Updated"

                };

            case "call":

                return{

                    icon:<Phone size={16}/>,

                    title:"Call"

                };

            case "whatsapp":

                return{

                    icon:<MessageCircle size={16}/>,

                    title:"WhatsApp"

                };

            default:

                return{

                    icon:<Clock3 size={16}/>,

                    title:"Activity"

                };

        }

    }

    return(

        <Card className="crm-remarks-card">

            <div className="crm-card-title">

                Activity Timeline

            </div>

            <div className="crm-remarks-list">

                {

                    !activities.length

                    ?

                    <div className="crm-empty">

                        No activities yet.

                    </div>

                    :

                    activities.map(activity=>{

                        const item =

                            getActivity(activity);

                        return(

                            <div

                                key={activity.id}

                                className="crm-activity"

                            >

                                <div className="crm-activity-icon">

                                    {item.icon}

                                </div>

                                <div className="crm-activity-content">

                                    <div className="crm-activity-header">

                                        <strong>

                                            {item.title}

                                        </strong>

                                        <span>

                                            {

                                                formatDate(

                                                    activity.created_at

                                                )

                                            }

                                        </span>

                                    </div>

                                  

                                    {

                                        activity.description &&

                                        <div className="crm-activity-description">

                                            {activity.description}

                                        </div>

                                    }

                                </div>

                            </div>

                        );

                    })

                }

            </div>

            <div className="crm-remark-editor">

                <textarea

                    rows={4}

                    value={remark}

                    placeholder="Write a remark..."

                    onKeyDown={handleKeyDown}

                    onChange={e=>

                        setRemark(

                            e.target.value

                        )

                    }

                />

                <div className="crm-editor-footer">

                    <small>

                        Ctrl + Enter to submit

                    </small>

                    <Button

                        loading={loading}

                        icon={<Send size={16}/>}

                        onClick={handleSubmit}

                    >

                        Add Remark

                    </Button>

                </div>

            </div>

<style>{`

.crm-remarks-card{

    display:flex;

    flex-direction:column;

    gap:20px;

}

.crm-remarks-list{

    display:flex;

    flex-direction:column;

    gap:18px;


    overflow:auto;

}

.crm-activity{

    display:flex;

    gap:14px;

}

.crm-activity-icon{

    width:36px;

    height:36px;

    border-radius:50%;

    background:#EEF4FF;

    color:#2563EB;

    display:flex;

    align-items:center;

    justify-content:center;

    flex-shrink:0;

}

.crm-activity-content{

    flex:1;

    border:1px solid #E5E7EB;

    border-radius:12px;

    padding:14px;

    background:#FFF;

}

.crm-activity-header{

    display:flex;

    justify-content:space-between;

    align-items:center;

    gap:10px;

    margin-bottom:8px;

}

.crm-activity-header span{

    font-size:12px;

    color:#94A3B8;

}

.crm-activity-title{

    font-weight:600;

    margin-bottom:6px;

}

.crm-activity-description{

    line-height:1.6;

    color:#475569;

}

.crm-empty{

    padding:30px;

    text-align:center;

    color:#94A3B8;

}

.crm-remark-editor{

    display:flex;

    flex-direction:column;

    gap:12px;

}

.crm-remark-editor textarea{

    min-height:100px;

    resize:vertical;

    border:1px solid #D7DCE3;

    border-radius:12px;

    padding:14px;

    outline:none;

    transition:.18s;

}

.crm-remark-editor textarea:focus{

    border-color:#2563EB;

    box-shadow:0 0 0 3px rgba(37,99,235,.12);

}

.crm-editor-footer{

    display:flex;

    justify-content:space-between;

    align-items:center;

}

.crm-editor-footer small{

    color:#94A3B8;

}

`}</style>

        </Card>

    );

}